var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15250_14057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 5.99998C8.50004 5.72384 8.27618 5.49998 8.00004 5.49998C7.7239 5.49998 7.50004 5.72384 7.50004 5.99998V7.49998H6.00004C5.7239 7.49998 5.50004 7.72384 5.50004 7.99998C5.50004 8.27612 5.7239 8.49998 6.00004 8.49998H7.50004V9.99998C7.50004 10.2761 7.7239 10.5 8.00004 10.5C8.27618 10.5 8.50004 10.2761 8.50004 9.99998V8.49998H10C10.2762 8.49998 10.5 8.27612 10.5 7.99998C10.5 7.72384 10.2762 7.49998 10 7.49998H8.50004V5.99998Z",
    fill: "#4141F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 0.833313C4.042 0.833313 0.833374 4.04194 0.833374 7.99998C0.833374 11.958 4.042 15.1666 8.00004 15.1666C11.9581 15.1666 15.1667 11.958 15.1667 7.99998C15.1667 4.04194 11.9581 0.833313 8.00004 0.833313ZM1.83337 7.99998C1.83337 4.59422 4.59428 1.83331 8.00004 1.83331C11.4058 1.83331 14.1667 4.59422 14.1667 7.99998C14.1667 11.4057 11.4058 14.1666 8.00004 14.1666C4.59428 14.1666 1.83337 11.4057 1.83337 7.99998Z",
    fill: "#4141F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15250_14057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDashboard);
export default __webpack_public_path__ + "static/media/newDashboard.8ad9580b998fb731ede131f11d716574.svg";
export { ForwardRef as ReactComponent };